export default "__VITE_ASSET__DB3PDbjY__"